// src/components/movimentacao-financeiro/MovimentacaoFinanceiroForm.jsx
import React from 'react';
import { Grid } from '@material-ui/core';
import QCXFinalForm from '../../shared-components/final-form/QCXFinalForm';
import QCXSelectDespesaReceitaOperacionalAutoComplete
  from '../../shared-components/select-despesa-receita/QCXSelectDespesaReceitaOperacionalAutoComplete';
import QCXSelectFollowUpAutocompleteField from '../../shared-components/select-follow-up/QCXSelectFollowUpAutocompleteField';
import QCXSelectContaBancariaAutocompleteField
  from '../../shared-components/select-conta-bancaria/QCXSelectContaBancariaAutocompleteField';
import QCXSelectFornecedorAutocomplete from '../../shared-components/select-fornecedor-favorecido-autocomplete/QCXSelectFornecedorAutocomplete';
import QCXFinalAlternativeCurrencyField
  from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXFinalDateTimePickerField
  from '../../shared-components/final-date-time-picker-field/QCXFinalDateTimePickerField';
import { required as requiredValidator } from '../../utils/validators/field/validator';

export default function MovimentacaoFinanceiroForm({
  initialValues, handleSubmit, isConsult, isUpdate,
  handleChangeToUpdate, handleCancelUpdate, ...restProps
}) {

  return (
    <QCXFinalForm
      isConsult={isConsult}
      isUpdate={isUpdate}
      initialValues={initialValues}
      handleSubmitValues={handleSubmit}
      handleChangeToUpdate={handleChangeToUpdate}
      handleCancelUpdate={handleCancelUpdate}
      {...restProps}
    >
      {({ values, form }) => (
        <>

          <Grid item xs={12} sm={12} md={6}>
            <QCXSelectFollowUpAutocompleteField
              name="followUp.id"            /* the path inside Final‑Form       */
              label="Processo (Follow‑up)"  /* field label                      */
              initialValues={initialValues} /* so it shows the current value    */
              disabled /* lock in UPDATE / CONSULT      */
              required
              lockSelect
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <QCXSelectDespesaReceitaOperacionalAutoComplete
              name="despesaReceita.id"
              label="Item Despesa/Receita"
              initialValues={initialValues}
              onlyDespesa={false}
              onChange={(event, value) => {
                if (!value) return;
                const newTipo = value.tipo === 'DESPESA' ? 'PAGAR' : 'RECEBER';
                form.change('tipo', newTipo);
              }}
              fieldProps={{ validate: requiredValidator }}
              disabled={isConsult}
              required
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <QCXSelectContaBancariaAutocompleteField
              name="contaBancaria.id"
              label="Conta Bancária (Cliente)"
              initialValues={initialValues}
              filtraCliente
              disabled={isConsult}
              required
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <QCXSelectFornecedorAutocomplete
              name="fornecedor.id"
              label="Fornecedor"
              initialValues={initialValues}
              disabled={isConsult}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <QCXFinalAlternativeCurrencyField
              name="valor"
              label="Valor"
              adorned
              required
              disabled={isConsult}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <QCXFinalDateTimePickerField
              name="dataOperacao"
              label="Data de Pagamento"
              disablePast={false}
              disabled={isConsult}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <QCXFinalDateTimePickerField
              name="insertionDate"
              label="Data de Solicitação"
              disabled
              disableFuture
            />
          </Grid>
        </>
      )}
    </QCXFinalForm>
  );
}
